import { z } from 'zod';

import { LoanStatus, TransferringLoanStatus } from '@willow/types-iso';

export const isTransferringLoan = (loanStatus: LoanStatus): boolean => {
  return z.validate(TransferringLoanStatus, loanStatus);
};
